import gsap from "gsap";

const OVERLAY_STYLE = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "white",
  zIndex: 1,
  pointerEvents: "none",
  willChange: "transform",
};

export class HeroImages {
  constructor() {
    this._images = document.querySelectorAll(".s-hero img");

    if (this._images.length) {
      this.init();
    }
  }

  init() {
    this._images.forEach((image, index) => {
      const parent = image.parentElement;
      if (!parent) return;

      if (window.getComputedStyle(parent).position === "static") {
        parent.style.position = "relative";
      }

      const overlay = document.createElement("div");
      Object.assign(overlay.style, OVERLAY_STYLE);
      parent.insertBefore(overlay, image);

      image.style.opacity = "1";

      gsap.fromTo(
        overlay,
        { y: 0 },
        {
          y: "-100%",
          duration: 1,
          ease: "power2.inOut",
          delay: index * 0.1,
          onComplete: () => {
            overlay.style.willChange = "auto";
            overlay.remove();
          },
        }
      );
    });
  }
}
